import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// Connects to data-controller="toggle"
export default class extends Controller {
  static values = {
    // trueなら非表示なパネル内部のinputをdisabledにする
    disableInputs: Boolean,
  };
  static targets = ["true", "false", "checkbox", "panel"];

  connect() {
    this.updatePanelVisibility();
  }

  updatePanelVisibility() {
    const panel = this.panelTarget;
    let isActive = false;

    if (this.hasTrueTarget) {
      isActive = this.trueTarget.checked;
    } else if (this.hasCheckboxTarget) {
      isActive = this.checkboxTarget.checked;
    }

    this.togglePanel(panel, isActive);
  }

  togglePanel(panel, isActive) {
    if (isActive) {
      $(panel).stop().slideDown();
    } else {
      $(panel).stop().slideUp();
    }
    if (this.disableInputsValue) {
      this.#updateInputsDisabled(panel, !isActive);
    }
  }

  #updateInputsDisabled(panel, disabled) {
    for (const input of panel.querySelectorAll("input, select, textarea")) {
      input.disabled = disabled;
    }
  }
}
